import { api } from '@services';

const deletePicture = async (id: string): Promise<void> => {
  await api.delete(`/pictures/${id}`);
};

export { deletePicture };
